import React from "react";
import Router from "./Router";
import "~src/sass/index.sass";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "~src/context/authContext";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import { GREEN, NAVBAR_BLUE } from "~src/data/constant";

const theme = createTheme({
  palette: {
    primary: {
      main: NAVBAR_BLUE,
    },
    secondary: {
      main: GREEN,
    },
  },
});

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
